import { getTradeAreaPalettesDictionary as t } from "./index.es51.js";
import { getTrafficVolumePalettesDictionary as i } from "./index.es50.js";
import { getHeatMapPalettesDictionary as o } from "./index.es49.js";
import { getDemographicPalettesDictionary as c } from "./index.es47.js";
import { getDivergingPalettesDictionary as m } from "./index.es48.js";
const n = (e, r) => {
  switch (e) {
    case "diverging":
      return m(r);
    case "demographics":
      return c(r);
    case "heatmap":
      return o(r);
    case "traffic-volume":
      return i(r);
    case "trade-area":
      return t(r);
  }
}, p = ({
  paletteToConvert: e,
  itemsLength: r
}) => n("trade-area", r).find(
  ({ paletteName: a }) => a === (e == null ? void 0 : e.paletteName.replace("TA1", `TA${r}`))
);
export {
  p as convertTradeAreaPaletteFromOneCount,
  n as getPallettesByCategoryAndBucket
};
//# sourceMappingURL=index.es52.js.map
